module.exports = __webpack_public_path__ + "img/lazer2.2e29fdc3.svg";